
import React from 'react';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import Typography from '@mui/material/Typography';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';


import IDLogin from './IDLogin';
import UserLogin from './UserLogin';

interface LoginPageMobileProps {
    loginData: {
        username: string;
        password: string;
        agree: boolean;
    };
    valid: boolean[];
    loginError: string;
    onLogin: () => void;
    onLoginIdAustria: () => void;
    handleInputChange: (value: string, id?: string) => void;
    handleCheckboxChange: (selected: boolean, id?: string) => void;
}

const LoginPageMobile: React.FC<LoginPageMobileProps> = ({
    loginData,
    valid,
    loginError,
    onLogin,
    onLoginIdAustria,
    handleInputChange,
    handleCheckboxChange,
}) => (
    <div>
        <Accordion sx={{
            '&:before': { display: 'none' },
            '& .MuiAccordionSummary-expandIconWrapper': {
                color: '#E1320F'
            }
        }} style={{ margin: '16px 0px', backgroundColor: '#EDF4FA', borderRadius: '16px', padding: '10px', border: '1px solid #DCE9F5' }}>
            <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel1-content"
                id="panel1-header"
            >
                <h2 className='subtitle-homepage'>Anmeldung mit ID Austria</h2>
            </AccordionSummary>
            <AccordionDetails>
                <IDLogin onLoginIdAustria={onLoginIdAustria} />
            </AccordionDetails>
        </Accordion>
        <Accordion sx={{
            '&:before': { display: 'none' },
            '& .MuiAccordionSummary-expandIconWrapper': {
                color: '#E1320F'
            }
        }} style={{ margin: '16px 0px', backgroundColor: '#EDF4FA', borderRadius: '16px', padding: '10px', border: '1px solid #DCE9F5' }}>
            <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel2-content"
                id="panel2-header"
            >
                <h2 className='subtitle-homepage'>Anmeldung mit Benutzername</h2>
            </AccordionSummary>
            <AccordionDetails>
                <UserLogin
                    loginData={loginData}
                    valid={valid}
                    loginError={loginError}
                    onLogin={onLogin}
                    onInputChange={handleInputChange}
                    onCheckboxChange={handleCheckboxChange}
                    isMobile={true}
                />
            </AccordionDetails>
        </Accordion>
    </div>
);

export default LoginPageMobile;
